// @flow
export const enforceMinimumRange = (
    params: Object,
    minKey: string,
    rangeFrom: number,
    rangeTo: number
): Object => {
    // check that minimum is in a valid range
    if (params[minKey]) {
        params[minKey] = Math.max(params[minKey], rangeFrom);
        params[minKey] = Math.min(rangeTo, params[minKey]);
    }
    return params;
};

export const enforceMaximumRange = (
    params: Object,
    minKey: string,
    maxKey: string,
    rangeFrom: number,
    rangeTo: number
): Object => {
    /* If maximum is defined but it outside the range of rangeTo to rangeFrom
    or its less than the minimum then delete it */
    if (params[maxKey]) {
        if (
            params[maxKey] > rangeTo ||
            params[maxKey] < rangeFrom ||
            (params[minKey] && params[maxKey] < params[minKey])
        ) {
            delete params[maxKey];
        }
    }

    return params;
};

export const paramsHasMinFieldorMaxField = (
    params: Object,
    minField: string,
    maxField: string
): 0 | 1 => {
    return params[minField] || params[maxField] ? 1 : 0;
};
